import { keycloak } from "@/auth/keycloak.ts";
import { useCallback } from "react";

export function useAuth() {
  const login = useCallback(async (): Promise<void> => {
    await keycloak.login();
  }, []);

  const logout = useCallback(async (): Promise<void> => {
    await keycloak.logout();
  }, []);

  const isAuthenticated = keycloak.authenticated;

  return { login, logout, isAuthenticated };
}
